module.exports = __webpack_public_path__ + "img/Support-skill-526.719ca230.png";